import React, {Fragment, useContext, useEffect, useState} from 'react';
import {Tooltip, Button, Modal, Typography, Radio, Form, Input, notification} from 'antd';
import {TagOutlined} from '@ant-design/icons';
import {OpenApiContext} from '../openapi-context';
import semver from 'semver';

function PublishVersionModal({visible, setVisible, workgroup, spec, specKey}) {
    const {backend} = useContext(OpenApiContext);
    const [changeType, setChangeType] = useState('patch');
    const [note, setNote] = useState('');
    const [version, setVersion] = useState();

    const publishVersion = async () => {
        try {
            await backend.publishVersion(workgroup, specKey, {
                comment: note,
                version,
                type: changeType,
            });
            notification.success({title: 'New specification version has been created!', placement: 'bottomRight'});
            setVisible(false);
        } catch (err) {
            notification.error({title: 'Unable to publish version', description: err.message, placement: 'bottomRight'});
        }
    };

    useEffect(() => {
        if (!spec.info.version) {
            setVersion(semver.inc('0.0.0', changeType));
        } else {
            setVersion(semver.inc(spec.info.version, changeType));
        }
    }, [changeType, spec.info.version]);

    return (
        <Modal
            width={800}
            title="Publish Version"
            open={visible}
            closable={true}
            onCancel={() => setVisible(false)}
            footer={[
                <Button key="cancel" className="addRef" onClick={() => setVisible(false)}>
                    Cancel
                </Button>,
                <Button key="submit" className="addField" type="primary" onClick={publishVersion}>
                    Publish
                </Button>,
            ]}>
            <Form layout="vertical">
                <Form.Item>
                    <Typography.Text>Publish your local changes to create a new specification version</Typography.Text>
                </Form.Item>
                <Form.Item label="Change Type">
                    <Radio.Group value={changeType} onChange={(e) => setChangeType(e.target.value)}>
                        <Radio value="patch">Patch</Radio>
                        <Radio value="minor">Minor</Radio>
                        <Radio value="major">Major</Radio>
                    </Radio.Group>
                </Form.Item>
                <Form.Item label="Version">
                    <Input value={version} onChange={(e) => setVersion(e.target.value)} />
                </Form.Item>
                <Form.Item label="Comments">
                    <Input.TextArea value={note} rows={4} placeholder="Add a comment to describe this version" onChange={(e) => setNote(e.target.value)} />
                </Form.Item>
            </Form>
        </Modal>
    );
}

export function PublishVersionDialog({workgroup, specKey, spec}) {
    const [visible, setVisible] = useState();

    return (
        <Fragment>
            <Tooltip placement="bottom" title={`Publish a new version for ${workgroup}-${specKey}`}>
                <Button style={{marginTop: 7, marginLeft: 3}} onClick={() => setVisible(true)}>
                    <TagOutlined />
                </Button>
            </Tooltip>
            {visible && <PublishVersionModal visible={visible} setVisible={setVisible} specKey={specKey} workgroup={workgroup} spec={spec} />}
        </Fragment>
    );
}
